import useChart from './useChart';
import { VideoProgressEntry } from '@usacsmideo/types';

/**
 * Hook to read video progress from the Chart.
 * Uses the existing real-time listener via useChart.
 */
export function useVideoProgress(patientId: string) {
  const chartQuery = useChart(patientId);
  const chart = chartQuery.data;

  const getProgress = (videoId: string): VideoProgressEntry | undefined => {
    return chart?.VIDEO_PROGRESS?.[videoId];
  };

  const isCompleted = (videoId: string): boolean => {
    return chart?.VIDEO_PROGRESS?.[videoId]?.completed ?? false;
  };

  return {
    getProgress,
    isCompleted,
    isReady: chart !== undefined,
  };
}
